import { withFormsy } from 'formsy-react';
import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import styled from 'styled-components';

const ErrorMessage = styled.span`
	color: red;
	font-size: 12px;
	padding-left: 10px;
`;

class SimpleField extends Component {
	constructor(props) {
		super(props);
		this.changeValue = this.changeValue.bind(this);
		this.placeholder = this.props.placeholder;
	}

	changeValue(event) {
		// setValue() will set the value of the component, which in
		// turn will validate it and the rest of the form
		// Important: Don't skip this step. This pattern is required
		// for Formsy to work.
		this.props.setValue(event.currentTarget.value);
	}

	render() {
		// An error message is returned only if the component is invalid
		const errorMessage = this.props.getErrorMessage();

		return (
			<div className="input-field">
				<TextField
					hintText={this.placeholder}
					floatingLabelText={this.placeholder}
					onChange={this.changeValue}
					type="text"
					value={this.props.getValue() || ''}
					maxLength={this.props.maxLength || ''}
				/>
				<ErrorMessage>{errorMessage}</ErrorMessage>
			</div>
		);
	}
}

export default withFormsy(SimpleField);



// WEBPACK FOOTER //
// ./src/components/formsy/SimpleField.js